import { useContext } from 'react'
import { BpmTabBar } from "components/TabBar/BpmTabBar";
import { LoggedIn } from './LoggedIn'
import { NotLoggedIn } from './NotLoggedIn'
import { UserContext } from 'utils/getContext'
import 'static/css/recommend.css'

const Recommend = () => {
  // 获取登录状态
  const { userInfo } = useContext(UserContext)

  return (
    <div id='recommend'>
      <div className='recommend-title'>事项列表</div>
      {
        userInfo
          ?
          (
            <LoggedIn type={userInfo?.USER_TYPE} />
          )
          :
          (
            <NotLoggedIn />
          )
      }
      {/* 底部导航栏 */}
      <BpmTabBar />
    </div>
  )
}

export { Recommend }